import { css } from '@emotion/css';
import { theme } from 'Shared/ThemeProvider';
import { addItemAndOpen, StoreRepeater } from 'Shared/forms/StoreRepeater';
import { CopyItemPopup } from 'Shared/forms/CopyItemPopup';
import { copyComponentItem } from 'Shared/backend/widgets/copyComponentItem';
import { initImage, fieldsToKeep } from 'Shared/backend/widgets/CreationUtils';
import { StoreProvider, useStore } from 'Shared/StoreProvider';
import type {SlidesLayout} from 'Shared/model/Components';
import { ComponentTitle } from 'Shared/backend/widgets/ComponentTitle';
import { optionList } from 'Shared/backend/widgets/ComponentOptions';
import { VerticalConstraint } from 'Shared/backend/widgets/VerticalConstraint';
import { SeparatedComponentAndSelector } from 'Shared/backend/widgets/SeparatedComponentAndSelector';
import { useLayout } from 'Shared/backend/LayoutProvider';
import { Show, createSignal } from 'solid-js';
import { repeaterBarStyle } from 'Shared/backend/widgets/SectionList';

/*
	XXX Probably set slider speed in theme if modification is needed.
*/

const buttonRowStyle = css({
	display: 'flex',
	gap: '0.5em',
});

export function initSlides(old?:any)
{
	const {items} = fieldsToKeep(old);
	return {layout:'slides',height:{height:'80vh'},slides:items};
}

export function Slides(P:SlidesLayout)
{
	const detailsStyle = css({
		display: 'flex',
		flexDirection: 'column',
		gap: '0.8em',
	});

	const addSlideStyle = css(theme().button,{
		alignSelf: 'flex-start'
	});

	const slideStyle = css({
		borderLeft: 'solid 5px #f4f4f4',
		paddingLeft: '1em',
		display: 'flex',
		flexDirection : 'column',
		gap: '0.8em'
	});

	const sw = useStore();
	const lo = useLayout();
	let repeaterNode!:HTMLElement;

	const [showCopy, setShowCopy] = createSignal(false);

	const options = optionList(['image','styles','overlay','vertical'],['slides','popup','buttons']);

	return (
		<div class={detailsStyle}>
			<Show when={lo.layout()}>
				<StoreProvider {...sw} location={[...sw.location,'height']}>
					<VerticalConstraint {...P.height} label='Slide height' options={['parent','child','ratio','height']} />
				</StoreProvider>
			</Show>

			<StoreRepeater ref={repeaterNode}
				permission='edit'
				field='slides'
				renderTitle={i => <ComponentTitle {...i} />}
				hideDelete={!lo.layout()}
				barStyle={repeaterBarStyle}
			>
				{(item,index) => (
					<StoreProvider {...sw} location={[...sw.location,'slides',index]}>
						<div class={slideStyle}>
							<SeparatedComponentAndSelector {...P.slides[index]} layout={P.slides[index].layout} options={options} />
						</div>
					</StoreProvider>
				)}
			</StoreRepeater>

			<Show when={lo.layout()}>
				<div class={buttonRowStyle}>
					<button class={addSlideStyle}
						onClick={() => addItemAndOpen(sw,'slides',repeaterNode,initImage())}
					>
						<i class='fas fa-plus'/> Add slide
					</button>
					<Show when={P.slides?.length > 0}>
						<button class={addSlideStyle} onClick={() => setShowCopy(true)}>
							Copy slide
						</button>
					</Show>
				</div>
			</Show>

			<Show when={showCopy()}>
				<CopyItemPopup
					title='Copy slide'
					selectLabel='Slide to copy'
					count={P.slides.length}
					close={() => setShowCopy(false)}
					onCopy={i => copyComponentItem(sw, 'slides', P.slides, i).then(() => setShowCopy(false))}
				/>
			</Show>
		</div>
	);
}
